<ng-container *ngIf="summaryData.locationInfo?.comments">
  <hr *ngIf="!isFunnelDialog" class="divider" />
  <div class="d-flex flex-column">
    <span class="address-headers">{{ 'comments' | translate }}</span>
    <span class="comments">{{ summaryData.locationInfo?.comments }}</span>
  </div>
  <hr *ngIf="isFunnelDialog" class="divider" />
</ng-container>
